export default __webpack_public_path__ + "static/media/member-dm.04841068.png";